module.exports = __webpack_public_path__ + "static/media/money.1ef90dc7.svg";